export const SHOULD_DISPLAY_ICON = false;
export const SHOULD_USE_SECONDARY_VARIANT = true;
export const POINTS_TRANSLATION_KEY = 'points';
export const ONLY_SHOW_REDEEM_REWARD_IN_RESTAURANT_CTA = '';
export const CAN_REPLACE_REWARD = false;
